import React, {Component} from 'react';
import PropTypes from "prop-types";
import { withFormik, Form, Field } from 'formik';
import Yup from "yup";
import ImageUpload from "./ImgUpload";
import moment from 'moment';
import placeholder from '../../assets/img/placeholder.jpg';
import {NotificationManager} from 'react-notifications';

class renderBasicInfo extends Component {

    constructor(props){
        super(props);

        this.state = {
            subjectId: 0,
            chapterId: 0
        }
    }

    //LifeCycle Methods
    componentWillMount() {
        if(this.props.chapter.id){
            //this.props.getChapterPart(this.props.chapter.id, this.props.user.id);
        }


    }

    saveChapterPart = () => {

        if(this.props.values.title === ''){
            this.props.setErrors({ title: 'This field is required' })
            NotificationManager.error("Title is a required field.", "Missing required field");
        }else {
            let data = JSON.parse(JSON.stringify(this.props.values));

            let finish = data.finish;

            if(finish) {
                if (finish.split(":").length == 3) {
                    finish = moment.duration(finish).asSeconds();
                } else if (finish.split(":").length == 2) {
                    finish = moment.duration("00:" + finish).asSeconds()
                } else {
                    finish = moment.duration("00:00:" + finish).asSeconds()
                }
            }else{
                //finish = "00:00:00";
            }

            data.finish = finish;

            if (this.props.chapter.id) {
                if(this.props.subjectId){
                    data.subjectId = this.props.subjectId;
                }
                if(this.props.courseId){
                    data.courseId = this.props.courseId;
                }
                this.props.updateChapterPart(data, this.props.chapter.id, this.props.user.id);
            } else {
                data.number = this.props.number;
                data.subjectId = this.props.subjectId;
                data.courseId = this.props.courseId;
                this.props.addChapterPart(data, this.props.chapterId, this.props.user.id);
            }

            this.props.onSave();

            finish = moment.utc(finish * 1000).format('HH:mm:ss');
        }
    }

    //Renders
    renderBasicInfoForms = () => (
        <div className="col-sm-6">
            <div className="form-group">
                <label>Title</label>
                <Field
                    type="text"
                    name='title'
                    className="form-control"
                    placeholder="Title"
                    defaultValue={this.props.chapter.title}

                />

                {
                    (this.props.touched.title && this.props.errors.title) &&
                    (
                        <p className="help-block">
                            {this.props.errors.title}
                        </p>
                    )
                }
            </div>
            <div className="form-group">
                <label>Description</label>
                <Field
                    className="form-control"
                    name='description'
                    component="textarea"
                    placeholder="Description"
                    rows="4"

                />
            </div>
            <div className="form-group">
                <label>Internal Notes</label>
                <Field
                    type="text"
                    className="form-control"
                    placeholder="Internal Notes"
                    name='notes'

                />
            </div>
            <div className="form-group">
                <label>Expected Finish Time</label>
                <Field
                    type="text"
                    className="form-control"
                    placeholder="HH:MM:SS"
                    name='finish'

                />
            </div>

            <div className="form-group">
                <label>Status</label>
                <Field
                    component="select"
                    className={`form-control ${this.props.values.status == "true" ? 'text-success' : 'text-danger'}`}
                    name='status'
                >
                    <option value="false">Inactive</option>
                    <option value="true">Active</option>
                    </Field>
            </div>
            <div className="form-group">
            
            <label>
                <div
                    className={`iradio_square video-modal-radio-wrapper ${this.props.values.feedbackPrompt ? 'checked' : ''}`}
                    // aria-checked="false"
                    // aria-disabled="false"
                >
                    <Field
                        className="invisible"
                        name="feedbackPrompt" component="input" type="checkbox" checked={this.props.values.feedbackPrompt}
                    />
                    <ins
                        className="iCheck-helper video-modal-radio-icon"
                    />
                </div>
                Prompt for feedback
            </label>
                
            </div>
        </div>
    );

    render() {
        const {
            isSubmitting,
            handleSubmit,
            handleReset,
            dirty
        } = this.props;
        return (
            <Form
                className="tab-pane no-padding active"
                id="chapter_part_basic_info"
                onSubmit={handleSubmit}
            >
                <div className="sp-10">
                    <div className="row">
                        {this.renderBasicInfoForms()}

                        <div className="col-sm-3">
                            <h4 className="image-title">Thumbnail</h4>
                            <div className="">
                                <ImageUpload
                                    onSave={this.props.onSaveImage}
                                    image={this.props.thumbnail ? this.props.thumbnail : placeholder}
                                    user={this.props.user}
                                    thumbnail={true}
                                    profileId={this.props.profile.id}
                                />
                            </div>
                        </div>
                        
                        <div className="col-sm-3">
                            <h4 className="image-title">Banner</h4>
                            <div className="">
                                <ImageUpload
                                    onSave={this.props.onSaveBanner}
                                    image={this.props.banner ? this.props.banner : placeholder}
                                    user={this.props.user}
                                    thumbnail={false}
                                    profileId={this.props.profile.id}
                                />
                            </div>
                        </div>

                    </div>
                </div>
                <div className="text-right sp-10">
                    <button
                        type="button"
                        className={
                            `btn btn-default disabled
                            ${!isSubmitting
                            && ' resetBasicInfo-btn'}`
                        }
                        onClick={this.props.isEditedInPreview ? this.props.handleCloseForm : handleReset}
                        disabled={!this.props.isEditedInPreview && (!dirty || isSubmitting)}
                    >
                        Cancel
                    </button> &nbsp;
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={this.saveChapterPart}
                    >
                        {this.props.view === 'edit' ? 'Save Changes' : 'Continue'}
                    </button>
                </div>
            </Form>
        )
    }
}

const EditBasicInfo = withFormik({
    mapPropsToValues({
                         chapter,
                         title,
                         description,
                         notes,
                         finish,
                         status,
                         feedbackPrompt
    })
    {
        if(chapter.finish) {
            finish = moment.utc(chapter.finish*1000).format('HH:mm:ss');


        }else if(finish) {


            if (finish >= 3660) {
                finish = moment.utc(chapter.finish * 1000).format('HH:mm:ss');
            } else if (finish >= 60) {
                finish = moment.utc(chapter.finish * 1000).format('mm:ss');
            } else {
                finish = moment.utc(chapter.finish * 1000).format('mm:ss');
            }
        }else{
            finish = "00:00:00";
        }

        return {
            title: chapter.title || '',
            description: description || chapter.description || '',
            notes: notes || chapter.notes || '',
            finish: finish || chapter.finish || '',
            feedbackPrompt: feedbackPrompt || chapter.feedbackPrompt || '',
            status: status || chapter.status || false
        };
    },

    validationSchema: Yup.object().shape({
        title: Yup.string().required('Title is required')
    }),


    handleSubmit(values, {setErrors, setSubmitting, props}) {
        setTimeout(() => {
            if (values.email === 'test@test.io') {
                setErrors({ email: 'This email is already token' })
            }else if(values.title === ''){
                setErrors({ title: 'This field is required' })
            }
            else {
                let finish = values.finish;

                if(finish.indexOf(":") > -1){
                    let split = finish.split(":");
                    if(split.length == 1){
                        //seconds
                        finish = split[0];
                    }else if(split.length === 2){
                        //minutes and seconds;
                        finish = (split[0] * 60) + split[1];

                    }else if(split.length === 3){
                        //hours, minutes, seconds;
                        finish = (split[0] * 3660) + (split[1] * 60) + split[2];
                    }
                }

                values.finish = finish;

                props.onChapterPartUpdate(values);
                if (props.isEditedInPreview) {
                    props.handleCloseForm();
                }
            }
        }, 200)
    }
})(renderBasicInfo);

EditBasicInfo.propTypes = {
    chapterPartInfo: PropTypes.object.isRequired,
    onChapterPartUpdate: PropTypes.func.isRequired,
    onLoad: PropTypes.func.isRequired
};

export default EditBasicInfo;


// WEBPACK FOOTER //
// ./src/components/EditChapterPart/EditBasicInfo.js